import { Controller } from '@hotwired/stimulus';
import { PaymentAccountsSearchMixin } from '../../../mixins/payment_accounts_search_mixin';

/*
Generic controller for initializing record search with payment accounts loading.
*/

export default class extends Controller {
  static values = {
    turboFrameTagName: String,
    selectSelector: String,
    klass: String,
  };

  initialize() {
    PaymentAccountsSearchMixin(this);
    this.initialize_payment_accounts_search(this.klassValue);
  }

  additional_turbo_params() {
    return { show_warnings: true };
  }
}
